import { Translate } from "../types"

const translate_IT: Translate =  {
    Language: {
        it: "Italiano",
        en: "Inglese",
        de: "Tedesco"
    },

    Municipal: {
        bolzano: "Bolzano",
        merano: "Merano",
        brunico: "Brunico",
        bressanone: "Bressanone"
    },

    Text: {
        select_cat_character_title: 'Scegli il gatto in cui ti identifichi di più',
        found: 'TROVATI',
        and: 'e',
        drag_here_answer: 'trascina qui la risposta',
        loading: 'Caricamento...',
        reset: 'Resetta',
        retry: 'Riprova',
        unableToLoadImage: "Impossibile caricare l'immagine",
        checkConnectionRetry: "Controlla la connessione e riprova",
        imageLoadError: "Errore nel caricamento dell'immagine.",
    },

    ErrorText: {
        invalid_qrcode: 'QRCODE sbagliato'
    },

    ButtonText: {
        start: 'START',
        next: 'AVANTI',
        confirm: 'CONFERMA',
        customise: 'PERSONALIZZA',
        cancel: 'ANNULLA',
        download: 'SCARICA',
        try_again: 'RIPROVALO',
        read_more: 'APPROFONDISCI'
    },

    PuzzleText:{
        station4: {
            bolzano: 'Giardino delle',
            merano: 'Park',
            bressanone: 'Giardini',
            brunico: 'Passeggiata'
        },

        station4_sport: {
            bolzano: {title: '263213715', text: 'Arrampicata, Karate, Calcio, Ciclismo, Golf, Sci, Pallavolo, Nuoto, Tennis'},
            merano: {title: '65157', text: 'Tennis, Calcio, Sci, Ciclismo, Arrampicata'},
            bressanone: {title: '3216', text: 'Karate, Calcio, Pallacanestro, Arrampicata'} ,
            brunico: {title: '55944', text: 'Karate, Calcio, Pallacanestro, Ciclismo, Nuoto'} 
        },

        station5_puzzle2: 'aciDi e ronzo'
    },

    CharacterDogType: {
        dog_geek: 'Brainy',
        dog_music: 'Folky',
        dog_sport: 'Stretchy',
        dog_fashion: 'Sparky'
    }
}

export default translate_IT;